import axios from "axios";
import config from "app/api/axiosConfig";
import { IRecordRequest } from "app/api/types";

export default (token: string, date: IRecordRequest["date"]) =>
  axios.get(
    `${process.env.REACT_APP_API_HOST}/admin/records?date=${date}`,
    config(token)
  );
